var beneficiaryBcomErrors = {
    bcomBeneErrors: [
        "BR_613",
        "BR_627",
        "BR_628",
        "BR_629",
        "BR_625",
        "BR_631",
        "BR_632",
        "BR_633",
        "BR_634",
        "BR_637",
        "BR_638",
        "BR_639",
        "BR_640",
        "BR_609",
        "AS_113",
        "AS_116"
    ],
    bcomAllAllocationErrorDetails: [
        {
            code: "BR_619",
            allocationPercent: "50",
            typeOfMessage: "messageWithForm"
        },
        {
            code: "BR_620",
            allocationPercent: "100",
            typeOfMessage: "messageWithForm"
        },
        {
            code: "BR_645",
            allocationPercent: "66.67",
            typeOfMessage: "messageWithForm"
        },
        {
            code: "BR_646",
            allocationPercent: "75",
            typeOfMessage: "messageWithForm"
        },
        {
            code: "BR_621",
            allocationPercent: "50",
            typeOfMessage: "message"
        },
        {
            code: "BR_622",
            allocationPercent: "100",
            typeOfMessage: "message"
        },
        {
            code: "BR_647",
            allocationPercent: "66.67",
            typeOfMessage: "message"
        },
        {
            code: "BR_648",
            allocationPercent: "75",
            typeOfMessage: "message"
        }
    ],
    bcomAllOtherErrorDetails: [
        "BR_614",
        "BR_613",
        "BR_627",
        "BR_628",
        "BR_629",
        "BR_625",
        "BR_617",
        "BR_615",
        "BR_623"
    ]
};

export default beneficiaryBcomErrors;
